import { TIER_CONTRACTS, TIER_MANAGER_CONTRACTS } from "./constants";
import thor from "../assets/images/cards/thor_table.png";
import odin from "../assets/images/cards/odin_table.png";
import heimdall from "../assets/images/cards/heimdall_table.png";
import freya from "../assets/images/cards/freya_table.png";


const tiers = {
  HEIMDALL: {
    name: "HEIMDALL",
    address: TIER_CONTRACTS.HEIMDALL,
    manager: TIER_MANAGER_CONTRACTS.HEIMDALL,
    image: heimdall,
  },
  FREYA: {
    name: "FREYA",
    address: TIER_CONTRACTS.FREYA,
    manager: TIER_MANAGER_CONTRACTS.FREYA,
    image: freya,
  },
  THOR: {
    name: "THOR",
    address: TIER_CONTRACTS.THOR,
    manager: TIER_MANAGER_CONTRACTS.THOR,
    image: thor
  },
  ODIN: {
    name: "ODIN",
    address: TIER_CONTRACTS.ODIN,
    manager: TIER_MANAGER_CONTRACTS.ODIN,
    image: odin
  },
};
export default tiers;
